import React, {useState} from 'react';
import {AutoComplete} from "primereact/autocomplete";
import targets from "data/kpi-targets.json";

const metrics = targets.sort((a, b) => a.name.localeCompare(b.name))

const TargetGoalTypeAutocomplete = ({onChange, value, disabled}) => {
    const [filteredTargets, setFilteredTargets] = useState(null);
    const [selectedTarget, setSelectedTarget] = useState(metrics.find(target => target.name === value));
    const searchTargets = (event) => {
        setTimeout(() => {
            let _filteredTargets;
            if (!event.query.trim().length) {
                _filteredTargets = [...metrics];
            }
            else {
                _filteredTargets = metrics.filter((target) =>
                    target.name.toLowerCase().startsWith(event.query.toLowerCase())
                );
            }

            setFilteredTargets(_filteredTargets);
        }, 250);
    }

    const handleChange = (e) => {
        setSelectedTarget(e.value);

        if(e.originalEvent.type === 'click') {
            onChange(e);
        }
    }

    return (
        <AutoComplete
            name="name"
            value={selectedTarget}
            suggestions={filteredTargets}
            completeMethod={searchTargets}
            field="name"
            forceSelection={true}
            dropdown
            onChange={handleChange}
            disabled={disabled} />);
}

export default TargetGoalTypeAutocomplete;
